import {AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {Router} from "@angular/router";
import {ManualWarehousingService} from "../manual-warehousing.service";
import {MovingDirection, WizardComponent} from "ng2-archwizard/dist";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {MessageType} from "../../../../shared/redux-store/session";

@Component({
  selector: 'vb-manual-warehousing',
  templateUrl: './manual-warehousing.component.html',
  styleUrls: ['./manual-warehousing.component.css'],
  providers: [ManualWarehousingService]
})
export class ManualWarehousingComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  currentStep: number;

  canExitDataPageProxy = (direction: MovingDirection) => this.canExitDataPage.apply(this, [direction]);
  canExitArticlePageProxy = (direction: MovingDirection) => this.canExitArticlePage.apply(this, [direction]);

  private isSaved: boolean = false;

  userEvent: Subject<any> = new Subject();

  @HostListener('document:keydown')
  handleUserKeyboardEvent() {
    this.userEvent.next();
  }

  @HostListener('document:click')
  handleUserClickEvent() {
    this.userEvent.next();
  }


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, public warehousingService: ManualWarehousingService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.userEvent.next();
  }

  onTimeout() {
    this.router.navigate(['/touch']);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.canExitArticlePage(MovingDirection.Forwards)) {
      if (!this.isSaved) {
        this.saveWarehousing();
      }
    } else {
      this.sessionActions.pushMessage("Wareneinlagerung wurde abgebrochen und nicht gespeichert!", MessageType.WARNING, "Wareneinlagerung");
    }
  }

  onStepChanged() {
    let step = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
    this.currentStep = step;
  }

  onFinalStepEntered() {
    this.onStepChanged();
    this.saveWarehousing();
  }

  saveWarehousing() {
    this.dataSubscriptions.push(this.warehousingService.saveManualWarehhousing().subscribe(res => {
        this.sessionActions.pushMessage("Wareneinlagerung erfolgreich abgeschlossen!", MessageType.SUCCESS, "Wareneinlagerung");
        this.isSaved = true;
        this.onGoHomeClicked();
      }, err => {
        this.sessionActions.throwError(err, "Fehler bei der Wareneinlagerung, bitte wenden Sie sich an den Support!", "Wareneinlagerung");
      }
    ));
  }

  onGoHomeClicked() {
    this.router.navigate(['/touch']);
  }

  private canExitDataPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return this.warehousingService.formControl.valid;
    }

    return false;

  }

  private canExitArticlePage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return this.warehousingService.formControl.valid && this.warehousingService.getNoIncrreasedStocks() > 0;
    } else {
      return true;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-warehousing/manual-warehousing/manual-warehousing.component.ts